<template>
    <span class="d-flex justify-content-end">
      <template v-if="loading">
        <ScIcon name="spinnerFW" class="mx-2 text-muted" />
      </template>
      <template v-else>
        <span class="form-check form-switch" @click="toggleActive()"
              v-sc-tooltip="active ? 'On.  Click to turn off' : 'Off.  Click to turn on'">
          <input type="checkbox" class="form-check-input" :checked="active" :disabled="disabled" />
          <label class="form-check-label"></label>
        </span>
      </template>
    </span>
</template>


<script>
    import ScIcon from './ScIcon.vue';

    export default {
      name: 'ScToggleOnOff',
      emits: ['sc-toggle'],
      components: {ScIcon},
      props: {
        loading: {type: Boolean, default: false},
        active: {type: Boolean, default: false},
        disabled: {type: Boolean, default: false}
      },
      methods: {
        toggleActive () {
          if (this.disabled) return;
          this.$emit('sc-toggle', !this.active);
        }
      }
    }

</script>